import api from './api/api';

export const findAll = async ({ page }) => api.get(`/users?page=${page - 1}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const findAllEntrepeneurUsers = async (name) => api.get(`/users/entrepreneur?name=${name}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getUser = async (userId) => api.get(`/users/${userId}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getMe = async () => api.get('/users/me').then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const saveMe = async (user) => api.put('/users/me', user).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const saveUser = async (user) => api.put(`/users/${user.id}`, user).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const deleteUserByAdmin = async (email) => api.delete(`/users/${email}`).then((response) => {
  if (response.status === 200) return;
  throw response.rejectException();
});

export const restoreUserByAdmin = async (email) => api.patch(`/users/restore/${email}`).then((response) => {
  if (response.status === 200) return;
  throw response.rejectException();
});

export const loadUserDetails = async () => {
  const me = await getMe();
  localStorage.setItem('me', JSON.stringify(me));
};

export const getUserDetails = () => JSON.parse(localStorage.getItem('me')) || {};
